// extracted by mini-css-extract-plugin
module.exports = {"ticker":"Borrowing_ticker__3S9L3","red":"Borrowing_red__3kO6E","load":"Borrowing_load__U0ZH6"};